import { STALE_TIME, GC_TIME, QUERY_PRESETS } from "@/queries/queryTimeConfig";

export const guestConfig = {
  /* ------------------------------- GET ----------------------------------- */

  getGuests: {
    key: "getGuests",
    url: "/api/v1/guests",
    method: "GET",
    options: {
      ...QUERY_PRESETS.LIST,
    },
  },

  getGuestById: {
    key: "getGuestById",
    url: (data) => `/api/v1/guests/${data.id}`,
    method: "GET",
    options: {
      ...QUERY_PRESETS.DETAIL,
    },
  },

  checkGuestActiveLine: {
    key: "checkGuestActiveLine",
    url: (params) => `/api/v1/guests/${params.guestId}/active-line`,
    method: "GET",
    options: {
      ...QUERY_PRESETS.DETAIL,
      staleTime: 0,
      enabled: false,
    },
  },

  getDeletedGuests: {
    key: "getDeletedGuests",
    url: "/api/v1/guests/deleted",
    method: "GET",
    options: {
      ...QUERY_PRESETS.LIST,
      keepPreviousData: false,
    },
  },

  /* ------------------------------- POST ---------------------------------- */

  createGuest: {
    key: "createGuest",
    url: "/api/v1/guests",
    method: "POST",
    options: {
      retry: 2,
      invalidateKeys: ["getGuests"],
    },
  },

  uploadGuestProfilePicture: {
    key: "uploadGuestProfilePicture",
    url: (data) => `/api/v1/guests/${data.id}/profile-picture`,
    method: "POST",
    options: {},
  },

  uploadIdentification: {
    key: "uploadIdentification",
    url: (data) => `/api/v1/guests/${data.id}/identifications`,
    method: "POST",
    options: {
      invalidateKeys: ["getGuestById"],
      onSuccessMessage: "Identification uploaded",
      onErrorMessage: "Failed to upload identification",
    },
  },

  /* ------------------------------- PATCH --------------------------------- */

  updateGuest: {
    key: "updateGuest",
    url: (data) => `/api/v1/guests/${data.id}`,
    method: "PATCH",
    options: {
      retry: 2,
      invalidateKeys: ["getGuests", "getGuestById"],
    },
  },

  restoreGuest: {
    key: "restoreGuest",
    url: (data) => `/api/v1/guests/${data.id}/restore`,
    method: "PATCH",
    options: {
      retry: 2,
      invalidateKeys: ["getGuests", "getDeletedGuests"],
    },
  },

  /* ------------------------------- DELETE -------------------------------- */

  deleteGuest: {
    key: "deleteGuest",
    url: (data) => `/api/v1/guests/${data.id}`,
    method: "DELETE",
    options: {
      retry: 2,
      invalidateKeys: ["getGuests", "getDeletedGuests"],
    },
  },

  removeIdentification: {
    key: "removeIdentification",
    url: (data) => `/api/v1/guests/${data.id}/identifications/${data.docId}`,
    method: "DELETE",
    options: {
      invalidateKeys: ["getGuestById"],
      onSuccessMessage: "Identification removed",
      onErrorMessage: "Failed to remove identification",
    },
  },
};
